import router from "@/router";
import VueCookies from "vue-cookies";

// import { firebaseApp } from "@/firebase";
import { clientsCollection } from "@/firebase";
import { orderMonthCollection } from "@/firebase";
import { orderDayCollection } from "@/firebase";
import { orderYearCollection } from "@/firebase";

const state = {
  client: {}, // current client / photo store data
  clients: [],
};

const getters = {};

const actions = {
  addClient({ commit }, payload) {
    clientsCollection.add(payload).then((docRef) => {
      commit("addClient", Object.assign(payload, { id: docRef.id }));
    });
  },
  removeClient({ commit }, payload) {
    clientsCollection
      .doc(payload)
      .delete()
      .then(() => {
        commit("removeClient", payload);
      });
  },
  editClient({ commit }, payload) {
    clientsCollection
      .doc(payload.id)
      .set(payload)
      .then(() => {
        commit("editClient", payload);
      });
  },
  async getClients({ commit }) {
    const querySnapshot = await clientsCollection
      .orderBy("basicSettings.name", "asc")
      .get();

    let tempData = [];
    querySnapshot.forEach(async (doc) => {
      let monthStats = {};
      let dayStats = {};
      let yearStats = {};

      await orderMonthCollection
        .where("client", "==", doc.data().basicSettings.name)
        .get()
        .then((snap) => {
          if (!snap.empty) {
            snap.forEach(async (doc2) => {
              monthStats = doc2.data();
            });
          }
        });
      await orderDayCollection
        .where("client", "==", doc.data().basicSettings.name)
        .get()
        .then((snap) => {
          if (!snap.empty) {
            snap.forEach(async (doc2) => {
              dayStats = doc2.data();
            });
          }
        });
      await orderYearCollection
        .where("client", "==", doc.data().basicSettings.name)
        .get()
        .then((snap) => {
          if (!snap.empty) {
            snap.forEach(async (doc2) => {
              yearStats = doc2.data();
            });
          }
        });

      tempData.push(
        Object.assign(doc.data(), {
          id: doc.id,
          dayStats: dayStats,
          monthStats: monthStats,
          yearStats: yearStats,
        })
      );
    });
    commit("getClients", tempData);
  },
  getClient({ commit }, payload) {
    return new Promise((resolve, reject) => {
      clientsCollection
        .where("basicSettings.name", "==", payload)
        .limit(1)
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function (doc) {
              commit("getClient", { payload: doc.data(), id: doc.id });
              if (
                VueCookies.isKey("client") &&
                VueCookies.get("client") !== doc.data().basicSettings.name
              ) {
                VueCookies.set("client", doc.data().basicSettings.name);
                router.replace("/");
              } else {
                VueCookies.set("client", doc.data().basicSettings.name);
              }
              resolve();
            });
          } else {
            resolve();
          }
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
          reject();
        });
    });
  },
  /*********************/
  /* SETTINGSCOLOR.VUE */
  /*********************/
  async saveSettingsColors({ commit }, payload) {
    let result = false;
    await clientsCollection
      .doc(this.state.storeClient.client.id)
      .set(payload, { merge: true })
      .then(() => {
        result = true;
        commit("saveSettingsColors", payload);
      });
    return result;
  },
  /*********************/
  /* SETTINGSOTHER.VUE */
  /*********************/
  async saveSettingsOther({ commit }, payload) {
    let result = false;
    await clientsCollection
      .doc(this.state.storeClient.client.id)
      .set(payload, { merge: true })
      .then(() => {
        VueCookies.set("orderPrintFontSize", payload.orderPrintSettings.size);
        VueCookies.set("orderPrintPageWidth", payload.orderPrintSettings.width);
        result = true;
        commit("saveSettingsOther", payload);
      });
    return result;
  },
  async saveSettingsCustomLoginImageFile({ commit }, payload) {
    let result = false;
    await clientsCollection
      .doc(this.state.storeClient.client.id)
      .set(payload, { merge: true })
      .then(() => {
        result = true;
        commit("saveSettingsCustomLoginImageFile", payload);
      });
    return result;
  },
  async saveSettingsCustomLogoImageFile({ commit }, payload) {
    let result = false;
    await clientsCollection
      .doc(this.state.storeClient.client.id)
      .set(payload, { merge: true })
      .then(() => {
        result = true;
        commit("saveSettingsCustomLoginImageFile", payload);
      });
    return result;
  },
  async saveSettingsCustomModuleMainImage({ commit }, payload) {
    let result = false;
    await clientsCollection
      .doc(this.state.storeClient.client.id)
      .set(payload, { merge: true })
      .then(() => {
        result = true;
        commit("saveSettingsCustomModuleMainImage", payload);
      });
    return result;
  },

  // eslint-disable-next-line
  toggleClientBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.active = !payload.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanVisible({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.visible = !payload.visible;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanModeratorActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.modules.moduleModerator.active = !payload.modules.moduleModerator.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanPhotoOrderActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.modules.modulePhotoOrder.active = !payload.modules.modulePhotoOrder.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanPhotoGiftActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.modules.modulePhotoGift.active = !payload.modules.modulePhotoGift.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanGiftCardActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.modules.moduleGiftCard.active = !payload.modules.moduleGiftCard.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanUserSettingsActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.modules.moduleUserSettings.active = !payload.modules.moduleUserSettings.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleClientBooleanPricingActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.pricing.active = !payload.pricing.active;
      clientsCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editClient", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  addClient(state, payload) {
    state.clients.push(payload);
  },
  removeClient(state, payload) {
    const index = state.clients.findIndex((item) => item.id == payload);
    state.clients.splice(index, 1);
  },
  editClient(state, payload) {
    const index = state.clients.findIndex((item) => item.id == payload.id);
    state.clients.splice(index, 1, payload);
  },
  getClients(state, payload) {
    state.clients = payload;
    //console.log(state.clients);
  },
  getClient(state, { payload, id }) {
    state.client = payload;
    state.client.id = id;
    //console.log(state.client);
  },
  saveSettingsColors(state, payload) {
    Object.assign(state.client.visualSettings.themeColor, payload);
  },
  // SETTINGSOTHER
  saveSettingsOther(state, payload) {
    // update vsak objekt zaključen posebej, sicer jih briše
    Object.assign(state.client.basicSettings, payload.basicSettings);
    Object.assign(state.client.loginSettings, payload.loginSettings);
    Object.assign(
      state.client.loginSettings.background,
      payload.loginSettings.background
    );
    Object.assign(
      state.client.environmentSettings,
      payload.environmentSettings
    );
    Object.assign(state.client.responseSettings, payload.responseSettings);
    Object.assign(state.client.orderPrintSettings, payload.orderPrintSettings);
  },
  saveSettingsCustomLoginImageFile(state, payload) {
    Object.assign(state.client.loginSettings, payload.loginSettings);
  },
  saveSettingsCustomModuleMainImage(state, payload) {
    Object.assign(
      state.client.modules.modulePhotoOrder,
      payload.modules.modulePhotoOrder
    );
    Object.assign(
      state.client.modules.modulePhotoGift,
      payload.modules.modulePhotoGift
    );
    Object.assign(
      state.client.modules.moduleGiftCard,
      payload.modules.moduleGiftCard
    );
    Object.assign(
      state.client.modules.moduleUserSettings,
      payload.modules.moduleUserSettings
    );
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
